import React from 'react';
import cn from 'classnames';

import styles from './MenuTranscibedItem.module.css';

const MenuTranscibedItem = ({ item, animate, delay }) => (
  <li
    className={cn(styles.wrapper, { [`${styles.animate}`]: animate })}
    style={{ animationDelay: `${delay}ms` }}
  >
    <span className="text-sm text-black font-bold">{item.name} </span>
    {item.prices.map((price, i) => {
      const type = i === 0 ? `| reg: ${price}` : ` | lg: ${price}`;
      return (
        <span key={`${item.name}-${price}`} className="text-sm text-black">
          {type}
        </span>
      );
    })}
  </li>
);

export default MenuTranscibedItem;
